import { base64ToBuffer } from "./base64Helper";

export const uploadFile = (urls, files) => {
    try {
        let file;
        let result=[];
        urls.forEach((url, index) => {
            file=base64ToBuffer(files[index]);
            result.push(url.split('?')[0]);
            fetch(url ,{
                method: "PUT",
                headers: {
                    "Content-Type":"multipart/form-data"
                },
                body: file
            })
        });
        return result;
    } catch (error) {
        return error;
    }
}